import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded px-1.5 py-0.5 text-[0.5625rem] font-bold uppercase tracking-wider',
  {
    variants: {
      variant: {
        default:
          'bg-[var(--inv-surface-muted)] text-[var(--inv-text-secondary)]',
        frontend: 'bg-blue-50 text-blue-700',
        backend:
          'bg-[var(--inv-accent-soft)] text-[var(--inv-accent)]',
        tag: 'rounded-full border border-[var(--inv-border-soft-2)] bg-[var(--inv-surface-muted)] px-2 py-0.5 text-[0.6875rem] font-medium normal-case tracking-normal text-[var(--inv-text-secondary)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
